export const TABS = [
  'Events',
  'Venues',
  'Cities',
  'Requested Events',
];

export const TAB_ROUTES = {
  Events: '/admin/events',
  Venues: '/admin/venues',
  Cities: '/admin/cities',
  'Requested Events': '/admin/requested-events',
};